import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import ComboModel from '../../models/ComboModel';
import Swal from 'sweetalert2';
import { 
  RiVipCrown2Fill, 
  RiCheckLine, 
  RiCloseLine, 
  RiRefreshLine,
  RiTimeLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine
} from 'react-icons/ri';

function ModalAdminComboOrders({ show, onHide, onUpdated }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('ALL');

  const fetchOrders = () => {
    setLoading(true);
    const params = {};
    if (filterStatus !== 'ALL') {
      params.status = filterStatus;
    }
    ComboModel.adminGetOrders(params)
      .then(res => {
        setLoading(false);
        if (res.data) {
          setOrders(res.data);
        }
      })
      .catch(err => {
        setLoading(false);
        console.error('Lỗi lấy đơn combo:', err);
      });
  };

  useEffect(() => {
    if (show) {
      fetchOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, filterStatus]);

  const handleApprove = (order) => {
    Swal.fire({
      title: 'Xác nhận duyệt đơn?',
      html: `Duyệt đơn <strong>#${order.id}</strong> cho khách hàng <strong>${order.user?.user_name || order.user_id}</strong>?<br/><br/>Hệ thống sẽ tự động cộng <strong>${order.slots} lượt tạo &amp; gia hạn bank</strong> (Bảo lưu <strong>VĨNH VIỄN trọn đời</strong>)!`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý duyệt',
      cancelButtonText: 'Hủy'
    }).then(result => {
      if (result.isConfirmed) {
        setLoading(true);
        ComboModel.adminApprove(order.id)
          .then(res => {
            setLoading(false);
            if (res.success) {
              Swal.fire({
                icon: 'success',
                title: 'Đã duyệt đơn thành công!',
                timer: 1800,
                showConfirmButton: false
              });
              fetchOrders();
              if (onUpdated) onUpdated();
            } else {
              Swal.fire({
                icon: 'error',
                title: res.message || 'Duyệt đơn thất bại!'
              });
            }
          })
          .catch(err => {
            setLoading(false);
            Swal.fire({
              icon: 'error',
              title: err?.response?.data?.message || 'Có lỗi xảy ra!'
            });
          });
      }
    });
  };

  const handleReject = (order) => {
    Swal.fire({
      title: 'Từ chối đơn hàng?',
      input: 'text',
      inputPlaceholder: 'Nhập lý do từ chối (tùy chọn)...',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Xác nhận từ chối',
      cancelButtonText: 'Hủy'
    }).then(result => {
      if (result.isConfirmed) {
        setLoading(true);
        ComboModel.adminReject(order.id, result.value || '')
          .then(res => {
            setLoading(false);
            if (res.success) {
              Swal.fire({
                icon: 'success',
                title: 'Đã từ chối đơn hàng!',
                timer: 1800,
                showConfirmButton: false
              });
              fetchOrders();
              if (onUpdated) onUpdated();
            } else {
              Swal.fire({
                icon: 'error',
                title: res.message || 'Thất bại!'
              });
            }
          })
          .catch(err => {
            setLoading(false);
            Swal.fire({
              icon: 'error',
              title: err?.response?.data?.message || 'Có lỗi xảy ra!'
            });
          });
      }
    });
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case 'PENDING':
        return (
          <span className="badge d-inline-flex align-items-center gap-1" style={{ background: 'var(--wus-warning-bg)', color: 'var(--wus-warning-text)', border: '1px solid var(--wus-warning-border)', padding: '5px 8px', borderRadius: '6px' }}>
            <RiTimeLine size={13} /> Chờ duyệt
          </span>
        );
      case 'APPROVED':
        return (
          <span className="badge d-inline-flex align-items-center gap-1" style={{ background: 'var(--wus-success-bg)', color: 'var(--wus-success-text)', border: '1px solid var(--wus-success-border)', padding: '5px 8px', borderRadius: '6px' }}>
            <RiCheckboxCircleLine size={13} /> Đã duyệt
          </span>
        );
      case 'REJECTED':
        return (
          <span className="badge d-inline-flex align-items-center gap-1" style={{ background: 'var(--wus-danger-bg)', color: 'var(--wus-danger-text)', border: '1px solid var(--wus-danger-border)', padding: '5px 8px', borderRadius: '6px' }}>
            <RiCloseCircleLine size={13} /> Đã từ chối
          </span>
        );
      default:
        return <span className="badge bg-secondary">{status}</span>;
    }
  };

  const getComboName = (type) => {
    switch (type) {
      case 'combo_1': return 'Combo 1 (5 lượt)';
      case 'combo_2': return 'Combo 2 (10+1 lượt)';
      case 'combo_3': return 'Combo 3 (20+2 lượt)';
      case 'combo_4': return 'Combo 4 (50+5 lượt)';
      default: return type;
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="modal-admin-combo-orders"
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <RiVipCrown2Fill style={{ color: 'var(--wus-warning-text)' }} size={20} />
          <span>QUẢN LÝ DUYỆT ĐƠN ĐĂNG KÝ COMBO VIP</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '20px' }}>
        {/* Filter and Refresh Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex gap-1 flex-wrap">
            <button
              type="button"
              className={`btn btn-sm ${filterStatus === 'ALL' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilterStatus('ALL')}
            >
              Tất cả
            </button>
            <button
              type="button"
              className={`btn btn-sm ${filterStatus === 'PENDING' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilterStatus('PENDING')}
            >
              Chờ duyệt
            </button>
            <button
              type="button"
              className={`btn btn-sm ${filterStatus === 'APPROVED' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilterStatus('APPROVED')}
            >
              Đã duyệt
            </button>
            <button
              type="button"
              className={`btn btn-sm ${filterStatus === 'REJECTED' ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilterStatus('REJECTED')}
            >
              Đã từ chối
            </button>
          </div>

          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={fetchOrders}
            disabled={loading}
          >
            <RiRefreshLine size={14} />
            <span>Làm mới danh sách</span>
          </button>
        </div>

        {/* Orders Table */}
        <div className="table-responsive" style={{ maxHeight: '550px', overflowY: 'auto' }}>
          <table className="table bank-table mb-0" style={{ fontSize: '13px' }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
              <tr>
                <th style={{ width: '60px', textAlign: 'center' }}>Mã #</th>
                <th>Khách hàng</th>
                <th>Gói Combo</th>
                <th style={{ textAlign: 'center' }}>Số lượt</th>
                <th style={{ textAlign: 'right' }}>Số tiền</th>
                <th style={{ textAlign: 'center' }}>Trạng thái</th>
                <th>Thời gian</th>
                <th style={{ textAlign: 'center', width: '160px' }}>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {loading && orders.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4" style={{ color: 'var(--wus-text-subtle)' }}>
                    Đang tải dữ liệu...
                  </td>
                </tr>
              ) : orders.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-4" style={{ color: 'var(--wus-text-subtle)' }}>
                    Không có đơn combo nào phù hợp.
                  </td>
                </tr>
              ) : (
                orders.map(order => (
                  <tr key={order.id}>
                    <td style={{ textAlign: 'center', color: 'var(--wus-text-subtle)', fontWeight: '600', fontFamily: 'var(--wus-mono)' }}>
                      #{order.id}
                    </td>
                    <td>
                      <div style={{ fontWeight: '600', color: 'var(--wus-text)' }}>
                        {order.user?.user_name || `User ID: ${order.user_id}`}
                      </div>
                      <div style={{ fontSize: '11.5px', color: 'var(--wus-text-subtle)' }}>
                        {order.user?.email || order.user?.name || ''}
                      </div>
                    </td>
                    <td>
                      <span className="badge-combo-vip">
                        {getComboName(order.combo_type)}
                      </span>
                    </td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: 'var(--wus-text)', fontFamily: 'var(--wus-mono)' }}>
                      {order.slots} lượt
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: '700', color: 'var(--wus-text)', fontFamily: 'var(--wus-mono)', fontSize: '13.5px' }}>
                      {Number(order.price).toLocaleString('vi-VN')} đ
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {renderStatusBadge(order.status)}
                    </td>
                    <td style={{ fontSize: '12px', color: 'var(--wus-text-muted)', fontFamily: 'var(--wus-mono)' }}>
                      {order.created_at ? new Date(order.created_at).toLocaleString('vi-VN') : '-'}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {order.status === 'PENDING' ? (
                        <div className="d-flex justify-content-center gap-1">
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={() => handleApprove(order)}
                            title="Duyệt đơn và cộng lượt"
                          >
                            <RiCheckLine size={14} /> Duyệt
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleReject(order)}
                            title="Từ chối đơn"
                          >
                            <RiCloseLine size={14} /> Từ chối
                          </button>
                        </div>
                      ) : (
                        <span style={{ fontSize: '12px', color: 'var(--wus-text-subtle)' }}>Đã xử lý</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalAdminComboOrders;
